import React from 'react';
import useReferralDiscount from 'products/nomad_insurance/hooks/useReferralDiscount';
import { DISCOUNT_TYPES } from 'products/nomad_insurance/constants';
import { getReferralRejectMessages } from './consts';
import { StyledFeedback, FeedbackHeading } from './styled';

const ReferralFeedback = () => {
  const { referralDiscount, isOfferLoading } = useReferralDiscount();

  if (isOfferLoading || !referralDiscount) return null;

  const discountTypeText =
    referralDiscount.discountType === DISCOUNT_TYPES.NI_C2C_REFERRAL
      ? 'referral credit'
      : 'gift card';

  const rejectHeader =
    referralDiscount.discountType === DISCOUNT_TYPES.NI_C2C_REFERRAL
      ? `You are not eligible for the $${referralDiscount.amount} referral credit`
      : `Your chosen policy is not eligible for the $${referralDiscount.amount} gift card`;

  if (referralDiscount.applied) {
    return (
      <StyledFeedback variant="success">
        Your ${referralDiscount.amount} {discountTypeText} has been automatically applied!
      </StyledFeedback>
    );
  }

  if (!referralDiscount.applied) {
    return (
      <StyledFeedback variant="failure" topAlignIcon>
        <FeedbackHeading>{rejectHeader}</FeedbackHeading>
        {getReferralRejectMessages(referralDiscount.amount).find(
          (x) => x.rejectReason === referralDiscount.rejectReason
        )?.message ?? ''}
      </StyledFeedback>
    );
  }

  return null;
};

export default ReferralFeedback;
